<ng-template #modal>
  <div class="modal-content">
    <div class="modal-header u-padding-vertical-0">
      <a>Editar Perfil</a>
      <mat-icon class="btn-fechar" (click)="fecharModal()">close</mat-icon>
    </div>

    <form [formGroup]="editForm" (submit)="editarPerfil()">
      <div>
        <label>Nome no Perfil</label>
        <input class="form-control" name="nome" formControlName="nome" placeholder="Digite aqui">

        <div class="text-danger" *ngIf="editForm.get('nome')?.invalid && editForm.get('nome')?.touched">
          <div *ngIf="editForm.get('nome')?.errors?.required">*O campo é obrigatório</div>
        </div>
      </div>

      <div>
        <label>Descrição do Perfil</label>
        <input class="form-control" name="descricao" formControlName="descricao" placeholder="Digite aqui">

        <div class="text-danger" *ngIf="editForm.get('descricao')?.invalid && editForm.get('descricao')?.touched">
          <div *ngIf="editForm.get('descricao')?.errors?.required">*O campo é obrigatório</div>
        </div>
      </div>

      <button type="submit" [disabled]="editForm.invalid || isButtonEnabled()" class="button-primary"> Editar
      </button>

    </form>
  </div>
</ng-template>